import { CreationLockResponse } from '../pages/shared/interfaces/creation-lock-response.interface';

/** iDefend signature states that mean successful payment / completed purchase. */
export const PAID_SIGNATURE_STATES = new Set([
  'confirmed',
  'signed',
  'authorized',
  'paid',
]);

export function isPaidSignatureState(
  signatureState: string | null | undefined,
): boolean {
  if (!signatureState) {
    return false;
  }
  return PAID_SIGNATURE_STATES.has(signatureState.toLowerCase());
}

/** Payment truth: iDefend `paidOn` is a date string after checkout, otherwise null. */
export function isOfferPaid(
  offer: CreationLockResponse | null | undefined,
): boolean {
  if (!offer) {
    return false;
  }
  const paidOn = offer.paidOn;
  return typeof paidOn === 'string' && paidOn.trim() !== '';
}

/** Maps iDefend signature state to payment modal UI status. */
export function mapSignatureStateToOfferStatus(
  offer: CreationLockResponse | null | undefined,
): string {
  if (!offer) {
    return 'PENDING';
  }

  switch (offer.signatureState) {
    case 'waiting_for_payment_before_signing':
      return 'WAITING_FOR_PAYMENT';
    case 'waiting_for_approval':
    case 'waiting_for_confirmation':
      return 'WAITING_FOR_APPROVAL';
    case 'confirmed':
    case 'signed':
    case 'authorized':
    case 'paid':
      return 'PAID';
    case 'cancelled':
      return 'CANCELLED';
    case 'rejected':
      return 'FAILED';
    case 'expired':
      return 'EXPIRED';
    case null:
    case undefined:
      return offer.paymentInitiationUrl ? 'WAITING_FOR_PAYMENT' : 'PENDING';
    default:
      return 'PENDING';
  }
}
